export { ReactComponent as LogoIcon } from './logo.svg';
export { ReactComponent as LogoDarkIcon } from './logo-dark.svg';
